import { getResourceTypes } from '@/api/alarmAdmin/alarm'
import { getNotificationList } from '@/api/alarmAdmin/notification'
import { ref, onMounted } from 'vue'
// 获取资源类型
export const getResourceTypesFun = (info) => {
  // 获取资源类型
  const options = ref([])
  const getFun = async() => {
    const res = await getResourceTypes(info)
    options.value = res.data.resource_types
  }
  onMounted(getFun)
  return options
}
// 获取通知对象
export const getNotificationsFun = () => {
  const options = ref([])
  const getFun = async() => {
    const res = await getNotificationList({ page_size: 1000 })
    options.value = res.data.notifications
  }
  onMounted(getFun)
  return options
}